export default class ErrorMessages {
  static serviceUnavailable = 'Serviço indisponível. Tente novamente mais tarde.';
  static defaultCredentialsError = 'Não pudemos validar suas credenciais. Tente novamente.';

  static resourceNotFound(resource) {
    return `${resource} não encontrado.`;
  }
}

export const getErrorMessageFromResponse = res => {
  try {
    if (res.error) {
      if (typeof res.error === 'string' || res.error instanceof String) {
        return res.error;
      }

      const keys = Object.keys(res.error);
      const error = res.error[keys[0]];

      if (typeof error === 'string' || error instanceof String) {
        return error;
      }

      if ((error.length ?? 0) > 0) {
        return error[0];
      }
    }
  } catch (e) {
    return null;
  }
  return null;
};
